import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../../components/layout/PageLayout';
import { pageFrameStyle } from '../../components/layout/PageFrame';
import Chevron from '../../components/content/Chevron';
import AppUiScope from '../../app-ui/AppUiScope';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import '../../features/browse/Browse.css';
import './PlaylistDetailSurface.css';
export default function PlaylistDetailShell({ playlist, children, position }) {
  const navigate = useNavigate(),
    { locale } = useWebLocale();
  const [compact, setCompact] = useState(false);
  useEffect(() => {
    const read = () => setCompact((old) => window.scrollY > (old ? 44 : 56));
    read();
    window.addEventListener('scroll', read, { passive: true });
    return () => window.removeEventListener('scroll', read);
  }, []);
  return (
    <AppUiScope surface="lists" className="pp-parity pp-browse pp-playlist-surface">
      <div className="pp-playlist-toolbar">
        <div className="pp-page-frame" style={pageFrameStyle}>
          <button
            aria-label={locale === 'en' ? 'Back' : '뒤로가기'}
            onClick={() => (window.history.state?.idx > 0 ? navigate(-1) : navigate('/lists'))}
          >
            <Chevron direction="left" />
          </button>
          <span>{compact ? playlist?.title : ''}</span>
          <span />
        </div>
      </div>
      <PageLayout paddingTop="52px">
        <div {...position}>{children}</div>
      </PageLayout>
    </AppUiScope>
  );
}
